import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchVoucher, createVoucher, updateVoucher } from './actions';
import VoucherSettingsForm from './SettingsForm';
import authUtils from '../../auth/utils';

class Details extends Component {
	constructor(props) {
		super(props);
		this.handleVoucherSettingsSubmit = this.handleVoucherSettingsSubmit.bind(this);
	}

	componentDidMount() {
		const { match, fetchVoucher } = this.props;
		const voucherId = match.params.id;
		
		if (voucherId) {
			fetchVoucher(voucherId);
		}
	}

	handleVoucherSettingsSubmit(values) {
		const { voucher, createVoucher, updateVoucher, history } = this.props;

		if (voucher) {
			updateVoucher(voucher.id, values);
		} 
	}
	
	render() {
		const { voucher, isReadonly } = this.props;
		if (voucher) {
			return (
				<VoucherSettingsForm isReadonly={isReadonly} onSubmit={this.handleVoucherSettingsSubmit} initialValues={voucher} />					
			);
		} 
	}
}

const mapStateToProps = (state, ownProps) => {
	const voucherId = ownProps.match.params.id;

	const {
		entities: { vouchers },
		auth: { currentUser }
	} = state;

	return {
		voucher: vouchers[voucherId],
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'Vouchers')
	};
};

export default connect(mapStateToProps, {
	fetchVoucher,
	updateVoucher
})(Details);